import React from 'react';
import dynamic from 'next/dynamic';

export default function DynamicHeroIcon(props) {
  const Icon = dynamic(() => import('@heroicons/react/outline').then((mod) => mod[props.name]));

  return <Icon className={props.className} aria-hidden="true" />;
}
